// extracted by mini-css-extract-plugin
export default {"status":"Answers_status__SZmxL","link":"Answers_link__pUPja"};